/**
 * @desc 地址解析
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** address */
  address: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<defs.store.CoordinateDTO>>(
    `/storeapi/inner/address/analysis`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<defs.store.CoordinateDTO>;
export default req;
